import { Box, Paragraph } from '@zillow/constellation-10';

export default function EmptyContainer() {
  return (
    <Box
      data-testid="renter-profile"
      css={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        justifyContent: 'center',
        paddingBottom: 'tighter',
        textAlign: 'center',
      }}
    >
      <Paragraph css={{ color: 'text.subtle' }}>See more information on a potential renter here.</Paragraph>
    </Box>
  );
}
